import React from "react";

import { Loader2, Wallet } from "lucide-react";
import { useTranslation } from "react-i18next";

const AddToWalletButton = ({ href, onLaunch, isLaunching = false }) => {
  const { t } = useTranslation(["walletOffer"]);

  return (
    <a
      href={href}
      onClick={onLaunch}
      aria-busy={isLaunching}
      className="group inline-flex min-h-[52px] w-full items-center justify-center gap-2.5 rounded-xl bg-cfPrimary px-[1.25rem] py-[0.75rem] text-base font-semibold text-cfSecondary no-underline shadow-[0_8px_20px_-8px_var(--cf-primary-color)] transition-all hover:bg-cfPrimaryDark hover:text-cfSecondary hover:no-underline active:scale-[0.98] focus:outline-none focus-visible:ring-2 focus-visible:ring-cfPrimary focus-visible:ring-offset-2"
    >
      {isLaunching ? (
        <Loader2 className="h-5 w-5 animate-spin" aria-hidden="true" />
      ) : (
        <Wallet
          className="h-5 w-5 transition-transform group-hover:-translate-y-0.5"
          aria-hidden="true"
        />
      )}
      {isLaunching
        ? t("walletOffer:opening_wallet")
        : t("walletOffer:add_to_wallet")}
    </a>
  );
};

export default AddToWalletButton;
